export enum TIME_FORMAT {
  TIME_FORMAT = 'HH:mm:ss',
  TIME_FORMAT_WITHOUT_SECOND = 'HH:mm',
}
